import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import { yupResolver } from "@hookform/resolvers/yup"
import { FieldError, SubmitHandler, useForm } from "react-hook-form"
import { FormInput } from "@/shared/ui/form-input"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeCreateVacancyModal, createVacancySchema, fetchCreateVacancy, selectIsCreateVacancyModalOpen, selectOnCreate } from "../../model"

interface CreateVacancyFormValues {
    name: string,
    description: string,
    salary: string,
    preview: File
}

const initialState: CreateVacancyFormValues = {
    name: "",
    description: "",
    salary: "",
    preview: null
}

export const CreateVacancyModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsCreateVacancyModalOpen)
    const onCreate = useAppSelector(selectOnCreate)

    const handleClose = () => {
        dispatch(closeCreateVacancyModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
            dispatch(fetchCreateVacancy({
                name: data.name,
                description: data.description,
                salary: data.salary,
                preview: data.preview
            }))
                .unwrap()
                .then(() => {
                    notify.success('Вакансия успешно создана')
                    reset()
                    onCreate?.()
                    res('')
                    handleClose()
                })
                .catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(createVacancySchema)
    })

    return (
        <Modal
            isOpen={isOpen}
            title="Создание вакансии"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    register={register}
                    label={"Название"}
                    id={"name"}
                    error={errors['name']}
                    required={true}
                    placeholder="Введите название вакансии"
                />
                <FormInput
                    register={register}
                    label={"Описание"}
                    id={"description"}
                    error={errors['description']}
                    required={true}
                    placeholder="Введите описание вакансии"
                />
                <FormInput
                    register={register}
                    label={"Зарплатная вилка"}
                    id={"salary"}
                    type="textarea"
                    rows={5}
                    error={errors['salary']}
                    required={true}
                    placeholder="Введите зарплатную вилку"
                />
                <FormInput
                    register={register}
                    label={"Превью (опционально)"}
                    id={"preview"}
                    type="file"
                    error={errors['preview'] as FieldError}
                    required={false}
                    placeholder=""
                />
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Добавить
                    </button>
                </div>
            </form>
        </Modal>
    )
}